import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { getFxEnabledRoles } from 'common/utils/user';

export const RECORDS_DASHBOARDS_PATH = '/manageSites/:studyId/:siteId/records/:type';

export const routes = [
    {
        component: lazy(() => import('module/managesites/ManageSitesListPage')),
        permissions: ['StudySite_Edit', 'StudySite_Create', 'StudySite_Delete', 'Study_Status_Edit', 'StudySite_Read'],
        path: '/manageSites/:studyId',
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.AdminReadOnly,
            ...getFxEnabledRoles(),
        ],
    },
    {
        component: lazy(() => import('module/managesites/ManageEOSPackagePage')),
        permissions: ['Study_Read'],
        path: '/manageSites/:studyId/eosPackage',
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.AdminReadOnly,
            ...getFxEnabledRoles(),
        ],
    },
    {
        component: lazy(() => import('module/managesites/RecordsDashboardsPage')),
        permissions: ['EOSDownload', 'EOSDownloadRecord_Read', 'EOSDownloadRecord_Edit'],
        path: RECORDS_DASHBOARDS_PATH,
        role: [BaseRoles.AdminId, RoleVariantEnum.StudySupport, RoleVariantEnum.AdminReadOnly, ...getFxEnabledRoles()],
    },
];
